import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-345efdf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-body" }
const _hoisted_2 = { class: "text-body-light" }
const _hoisted_3 = { class: "dialog-actions" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]

import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGettext } from 'vue3-gettext'
import DialogUI from '@/components/CommonUI/DialogUI.vue'
import { useUserStore } from '@/store/user'

interface Props {
  dismissible?: boolean,
}

const findOutMoreUrl = 'https://dittomusic.com/publishing'


export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeDialog',
  props: {
    dismissible: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const { $gettext } = useGettext()



const dashboardUrl = process.env.VUE_APP_DASHBOARD_URL
const dialog = ref<IDialogUI>()

const userStore = useUserStore()
const { hasStarterSubscription } = storeToRefs(userStore)

const buttonText = computed(() => (hasStarterSubscription.value
  ? $gettext('Upgrade Plan')
  : $gettext('Pick a Plan')))

const upgradeUrl = `${dashboardUrl}/subscriptions`
function show() {
  dialog.value?.show()
}
function hide() {
  dialog.value?.hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogUI, {
    ref_key: "dialog",
    ref: dialog,
    size: "small",
    "data-testid": "upgradeDialog",
    dismissible: _ctx.dismissible
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_unref($gettext)('You need to upgrade to access this area.')), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref($gettext)('Register tracks from your release library to claim up to 20% more royalties. Access exclusive sync opportunities to get your music on TV, movies and more.')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "button",
          href: upgradeUrl,
          title: buttonText.value
        }, _toDisplayString(buttonText.value), 9, _hoisted_4),
        _createElementVNode("a", {
          class: "button secondary black",
          href: findOutMoreUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          title: _unref($gettext)('Find out more')
        }, _toDisplayString(_unref($gettext)('Find out more')), 9, _hoisted_5)
      ])
    ]),
    _: 1
  }, 8, ["dismissible"]))
}
}

})